import script from "./imageloadcounter.vue?vue&type=script&lang=js"
export * from "./imageloadcounter.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__